const NAME = "TEMPLATES";

export default NAME;
